<template>
  <v-progress-circular
    :width="4" :size="size" color="var(--color-brand)"
    indeterminate
  />
</template>

<script>
export default {
  name: 'WaitData',
  props: {
    size: {
      type: String,
      default: '32'
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped></style>
